module.exports = __webpack_public_path__ + "static/media/wallfinishes_lcs_10y_y.26d6b49f.csv";